// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-19ffdc78] .avatar-participation-status__indicator{bottom:15px;left:47px;opacity:.45;position:relative}.avatar-participation-status__text[data-v-19ffdc78]{opacity:.45;left:69px;bottom:35px;white-space:nowrap;position:relative;min-width:220px;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
